import QuestionValue from "./QuestionValue";

export default class QuestionValueAngle extends QuestionValue {
    constructor(value, measurementCharacter) {
        super(value);
        this._measurentCharacter = measurementCharacter;
    }

    toString() {
        return "" + this.value + this._measurentCharacter;
    }
}